import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { HistoricoEventoService } from '../../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IActividadHistorico } from '../../../../../shared/interfaces/database/configuracion';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'app-pqrsd-actividades-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle, TabViewModule],
  templateUrl: './pqrsd-actividades-historico.component.html',
  styleUrl: './pqrsd-actividades-historico.component.scss'
})
export class PqrsdActividadesHistoricoComponent implements OnInit {
  title: string = 'title';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _hes: HistoricoEventoService, private readonly _t: TranslateService) { }

  ngOnInit(): void {
    this.translate().then(() => this.configColumns());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      codificacion: this._t.get('common.codificacion'),
      descripcion: this._t.get('common.descripcion'),
      rol: this._t.get('common.rol'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      historiaDeCambiosDeActividades: this._t.get('msg.historiaDeCambiosDeActividades')
    }));
    this.title = this.trans.historiaDeCambiosDeActividades;
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'codificacion',
          header: this.trans.codificacion,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'permisoCodificacion',
          header: this.trans.rol,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        }
      ]
    } as ICustomTable;

  }

  show(hojaDeVidaTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(hojaDeVidaTramiteId);
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(actividadId: number) {
    this._hes.getPqrsdActividadHistorico(actividadId).subscribe({
      next: (data: IActividadHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._hes.getPqrsdActividadHistoricoEliminado().subscribe({
      next: (data: IActividadHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
